"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLEAR = exports.UPDATE_CUSTOMMETA = exports.CHANGE_CATEGORY_NAME = exports.TOGGLE_CATEGORY = exports.UPDATE_FIELD = exports.SET_PROJECT = exports.SAVE_FAILED = exports.SAVE_SUCCESS = exports.SAVE_REQUEST = exports.STEP_VALIDATION_FAILED = exports.STEP_VALIDATION_SUCCESS = exports.CHANGE_STEP = void 0;
exports.CHANGE_STEP = `@sok/subproject/wizard/CHANGE_STEP`;
exports.STEP_VALIDATION_SUCCESS = `@sok/subproject/wizard/STEP_VALIDATION_SUCCESS`;
exports.STEP_VALIDATION_FAILED = `@sok/subproject/wizard/STEP_VALIDATION_FAILED`;
exports.SAVE_REQUEST = `@sok/subproject/wizard/SAVE_REQUEST`;
exports.SAVE_SUCCESS = `@sok/subproject/wizard/SAVE_SUCCESS`;
exports.SAVE_FAILED = `@sok/subproject/wizard/SAVE_FAILED`;
exports.SET_PROJECT = `@sok/subproject/wizard/SET_PROJECT`;
exports.UPDATE_FIELD = `@sok/subproject/wizard/UPDATE_FIELD`;
exports.TOGGLE_CATEGORY = `@sok/subproject/wizard/TOGGLE_CATEGORY`;
exports.CHANGE_CATEGORY_NAME = `@sok/subproject/wizard/CHANGE_CATEGORY_NAME`;
exports.UPDATE_CUSTOMMETA = `@sok/subproject/wizard/UPDATE_CUSTOMMETA`;
exports.CLEAR = '@sok/subproject/wizard/CLEAR';
//# sourceMappingURL=wizard.js.map